import {
  SectionBenefits,
  SectionBenefitsProps,
} from '@sbercloud/uikit-product-site-section';
import { useRouter } from 'next/navigation';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { type CatalogProduct } from 'src/types/backendContent';

const COLUMNS_CONFIG: SectionBenefitsProps['columnsConfig'] = {
  desktop: {
    amount: 3,
    minWidth: 272,
  },
  tablet: {
    amount: 2,
    minWidth: 272,
  },
  mobile: {
    amount: 1,
    minWidth: 272,
  },
};

export interface ProductsListProps {
  id?: string;
  title?: string;
  description?: string;
  products: CatalogProduct[];
  cardsWithShadow?: boolean;
  outline?: boolean;
}

export function ProductsList({
  id = 'services',
  title,
  description,
  products,
  outline,
}: ProductsListProps) {
  const layoutType = useLayoutType();
  const { clickAnalytics } = useAnalytics();
  const router = useRouter();

  const content: SectionBenefitsProps['content'] = products.map((product) => {
    const customLink = product.customLink
      ? `/${product.customLink}`
      : undefined;
    const productSlug = product.type
      ? `/${product.type}/${product.slug}`
      : product.slug;

    const href = customLink || productSlug;

    return {
      title: product.title,
      description: product.description,
      icon: {
        src: product.icon || '/plugs/product-2d-icon-default.svg',
        alt: product.title,
      },
      href,
      onClick: (e) => {
        e?.preventDefault();

        router.push(href);

        clickAnalytics({
          action: href,
          clickZone: 'body',
          clickElement: 'cardclick',
          clickContent: product.title,
          uniqueId: `catalog-product-${product.title}`,
          transitionType: 'inside-link',
        });
      },
    };
  });

  return (
    <SectionBenefits
      id={id}
      columnsConfig={COLUMNS_CONFIG}
      layoutType={layoutType}
      type="info"
      title={title}
      description={description}
      outline={outline}
      content={content}
    />
  );
}
